export function shouldHandleOpenPathBeforeEditorReady(pluginId, path) {
    return pluginId === 'cloud' && path.startsWith('cloud://');
}
